import { makeStyles } from "@mui/styles";
import {Theme} from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  iconSend: {
    width: "22px",
    height: "22px",
    color: theme.palette.gray60.main,
  },
  textInput: {
    "& .MuiOutlinedInput-input": {
      padding: 14,
    },
  },
}));

export default useStyles;
